import slide1 from './assets/slide-1.webp';
import slide2 from './assets/slide-2.webp';
import slide3 from './assets/slide-3.webp';
import slide4 from './assets/slide-4.webp';
import slide5 from './assets/slide-5.webp';

export const tabSliderContent = {
  slides: [
    {
      tab: 'камерность и тишина',
      image: slide1,
      title: 'приватный контур',
      subtitleAccent: 'архитектура дома бережно укрывает',
      subtitle: 'внутренний двор от\u00A0городской суеты.',
      descAccent:
        'конфигурация зданий образует приватное пространство, скрытое от шума улиц и посторонних глаз',
      desc: 'около 4 этажей создают камерную атмосферу, а вход во двор возможен только для жителей через систему контроля доступа',
    },
    {
      tab: 'внутренний двор',
      image: slide2,
      title: 'внутренний двор',
      subtitleAccent: 'ландшафтный парк \nс концепцией «Рябь на воде». ',
      descAccent:
        'территория внутри дома полностью отдана пешеходам. рельеф двора выполнен с использованием искусственных холмов, зонирующих пространство.',
      desc: 'для малышей и подростков предусмотрены раздельные игровые площадки, а для взрослых — тихие зоны с  навесами-парусами и зарядками для работы на свежем воздухе.',
    },
    {
      tab: 'прогулочный бульвар',
      image: slide3,
      title: 'прогулочный бульвар',
      subtitleAccent: 'центральная аллея к реке.',
      subtitle: '',
      descAccent:
        'главная пешеходная артерия, связывающая жилые корпуса с береговой линией. дорожки вымощены деревянным настилом и брусчаткой, что удобно для прогулок с колясками.',
      desc: ' вечером здесь включается торшерное освещение и гирлянды, создавая уютную атмосферу для променада.',
    },
    {
      tab: 'набережная у дома',
      image: slide4,
      title: 'набережная у дома',
      subtitleAccent: 'река как часть вашего повседневного маршрута. ',
      subtitle: '',
      descAccent:
        'начинайте утро с пробежки вдоль берега, выходите на прогулку с собакой или занимайтесь йогой под тихий шум воды. а',
      desc: ' вечерами спускайтесь к Каме, чтобы проводить закат,  неспешно пройтись перед сном или просто выпить кофе,  наслаждаясь речным бризом',
    },
    {
      tab: 'паркинг и сервисы',
      image: slide5,
      title: 'паркинг и сервисы',
      subtitleAccent: 'внешняя инфраструктура.',
      subtitle: '',
      descAccent:
        'все технические зоны вынесены  за пределы жилого двора. бесплатные парковочные места и зарядные станции для электромобилей расположены по внешнему периметру.',
      desc: 'ритейл и сервисы также имеют входы с улицы, чтобы не нарушать приватность жителей внутри квартала.',
    },
  ],
};
